import SocialsKeyLineText from "@casino/legacy/client/components/Auth/Shared/SocialsKeyLineText";
import SocialAuth from "@casino/legacy/client/features/SocialAuth";
import AuthBrandHeading from "@casino/legacy/client/shared/AuthBrandHeading";

type Props = {
  children: React.ReactNode;
  translateId: string;
  showSignUpSocialAuth?: boolean;
};

const RegisterWrapper: FC<Props> = ({
  children,
  translateId,
  showSignUpSocialAuth,
}) => (
  <div className="grid content-start gap-6">
    <AuthBrandHeading id={translateId} />
    {showSignUpSocialAuth && (
      <>
        <SocialAuth module="login" />
        <SocialsKeyLineText />
      </>
    )}
    <div className="grid gap-2">{children}</div>
  </div>
);
export default RegisterWrapper;
